import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  ADMIN_BIN,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchAdminBin = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ADMIN_BIN}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ADMIN_BIN}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ADMIN_BIN}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.ADMIN_BIN}${query}${sorting}`);
};

const postAdminBin = async payload => axiosAuthInstance.post(API_END_POINTS.ADMIN_BIN, payload);

const patchAdminBin = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.ADMIN_BIN}/${gid}`, params);

export function* getAdminBin(action) {
  try {
    const { data: { entity } } = yield call(fetchAdminBin, action.payload);
    yield put({ type: ADMIN_BIN.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ADMIN_BIN.FAILED, payload: e.response.data });
  }
}

export function* addAdminBin(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postAdminBin, action.payload);
    const { data: { entity } } = yield call(fetchAdminBin, action.payload);
    yield put({ type: ADMIN_BIN.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ADMIN_BIN.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* updateAdminBin(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchAdminBin, action.payload);
    const { data: { entity } } = yield call(fetchAdminBin, action.payload);
    yield put({ type: ADMIN_BIN.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ADMIN_BIN.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
